import Aos from "aos";
import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PriceList from "./Price.json";
import "./index.scss";

function Price() {
  Aos.init({
    delay: 500,
    once: true,
  });

  useEffect(() => {
    // document.title = "Lab Service Fees | Galaxy Gemological Institute";
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="price">
      <Helmet>
        <link
          rel="canonical"
          href="https://www.ggilab.com/laboratory/lab-service-fee"
        />
        <title>GGI Lab Service Charges | Galaxy Gemological Institute</title>
        <meta
          name="description"
          content="Discover our transparent lab service fees at Galaxy Gemological Institute. We offer reliable gemstone and jewelry assessments with competitive pricing."
        />
      </Helmet>
      <div className="container priceCon">
        {/* <div className="titleDiv">
					<h2 className="title" data-aos="fade-up">
						Discount Offers
					</h2>
					<p data-aos="fade-down">5 STONES ----------- 10% discount.</p>
					<p data-aos="fade-down">GGI Membership Card (valid for 1 year) -------- 25% discount.</p>
				</div> */}
        <div className="coursesTimeDiv" data-aos="flip-left">
          <div className="titleDiv">
            <h1 className="title" data-aos="fade-right">
              Rate Sheets
            </h1>
            <div className="customAccordion">
              {PriceList.map((pri) => {
                return (
                  <div className="accordionItem" data-aos="zoom-in">
                    <h2
                      className=" accordionHeader"
                      id="headingOne"
                      data-aos="zoom-in-up"
                    >
                      <p className="accordionButton" data-aos="zoom-in-up">
                        {pri.name}
                      </p>
                    </h2>
                    <div
                      id={pri.name}
                      className="accordionCollapse"
                      data-aos="zoom-in-up"
                    >
                      <div className="accordionBody" data-aos="zoom-in-up">
                        <div style={{ overflowX: "auto" }}>
                          <table className={pri.class}>
                            <thead>
                              {pri.headers ? (
                                <tr>
                                  <th colSpan="5" data-aos="zoom-in-up">
                                    Type of Testing
                                  </th>
                                  <th data-aos="zoom-in-up">{pri.headers}</th>
                                </tr>
                              ) : (
                                <tr>
                                  <th colSpan="5" data-aos="zoom-in-up">
                                    Type of Testing
                                  </th>
                                  <th data-aos="zoom-in-up"> MEMBER</th>
                                  <th data-aos="zoom-in-up"> NON MEMBER</th>
                                </tr>
                              )}
                            </thead>
                            <tbody>
                              {pri.Items.map((itm, i) =>
                                pri.headers ? (
                                  <tr key={i}>
                                    <td colSpan="5" data-aos="zoom-in-up">
                                      {itm.name}
                                    </td>

                                    <td data-aos="zoom-in-up">{itm.Fees}</td>
                                  </tr>
                                ) : (
                                  <tr key={i}>
                                    <td colSpan="5" data-aos="zoom-in-up">
                                      {itm.name}
                                    </td>

                                    <td data-aos="zoom-in-up">
                                      {itm.MemberPrice}
                                    </td>
                                    <td data-aos="zoom-in-up">
                                      {itm.NonMemberPrice}
                                    </td>
                                  </tr>
                                )
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="PriceFooter">
              <p>CVD Testing : 1500/ct for small parcels and jewellery. 2500/ct with grading.</p>
              <p>CVD Testing: 800/stone Members 1000/stone for Non members</p>
              <p>Appraisal Report of Plain Jewellery : Rs 1500/ first Article, 800/Per Article</p>
              <p>Appraisal Report of Loose Diamond or Gemstone: Rs 1500/- (After Identification of Stone)</p>
              <p>Appraisal Certificate of Studded Jewellery: Rs 1500/- Per Article (After Identification of Stones)</p>
              <p>Gold Testing: 600/article</p>
              <p>Sealing of diamond or gemstone will cost extra Rs 1500/-</p>
              <p>Origin (Only Ruby, Sapphire and Emerald) will cost extra Rs 500/-</p>
              <p>Note: Extra charges will be applied on urgent testing</p>
              {/* <p>Sealing Of Diamond Or Gemstone will Cost Extra Rs 1500 /-</p>
              <p>
                Origin (Only Ruby , Sapphire and Emerald) will Cost Extra Rs 500
                
                /-
              </p>
              <p>Note :- Extra Charges Would Be Applied For Urgent Testing</p> */}

              <table>
                <tr>
                  <td>MemberShip Fees :- </td>
                  <td> Rs 5000 (For New MemberShip)</td>
                </tr>
                <tr>
                  <td></td>
                  <td> Rs 3000 (For Renew)</td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = ({ store }) => ({});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Price);
